import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { ExpandedHistoryEventContainer } from './_Styled'

import ActivityEditEventItem from './ActivityEditEventItem'
import { sortActivitityEditAttributes } from '../../../utils/questhistory'

const ActivityEditEventsContainer = styled.ul`
  .activity-edit-text {
    border-bottom: 1px solid #dedfe0;
  }

  li:last-of-type div {
    border-bottom: none;
  }
`

const ActivityEditEventsList = props => {
  const sortedAttributes = sortActivitityEditAttributes(props.changedAttributes)
  const attributes = sortedAttributes.map(attribute => (
    <ActivityEditEventItem attribute={attribute} key={attribute} />
  ))
  return (
    <ExpandedHistoryEventContainer
      bg={getComputedStyle(props.parentRef.current).backgroundColor}
      style={{ padding: '0 58px 0 55px' }}
    >
      <ActivityEditEventsContainer>{attributes}</ActivityEditEventsContainer>
    </ExpandedHistoryEventContainer>
  )
}

ActivityEditEventsList.propTypes = {
  changedAttributes: PropTypes.array.isRequired,
  parentRef: PropTypes.object.isRequired
}

export default ActivityEditEventsList



// WEBPACK FOOTER //
// ./src/components/quest/questhistory/ActivityEditEventsList.js